'use strict'

const info = function() {
  if (console) console.info.apply(console, arguments)
}

const log = function() {
  if (console) console.log.apply(console, arguments)
}

const warn = function() {
  if (console) console.warn.apply(console, arguments)
}

const error = function() {
  if (console) console.error.apply(console, arguments)
}

const fatal = function() {
  if (console) console.fatal.apply(console, arguments)
}

const trace = function() {
  if (console) console.trace.apply(console, arguments)
}

export default {
  info,
  log,
  warn,
  error,
  fatal,
  trace
}
